// extracted by mini-css-extract-plugin
export default {"scrollToTopButton":"ScrollButton_scrollToTopButton__XeMjJ"};